// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__38gW-","container":"styles_container__2qjtN","title":"styles_title__zXIoT","wrapper":"styles_wrapper__2g9ml","answer":"styles_answer__15PiJ"};